import { useNavigate } from "react-router-dom";
import { Heart, XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen grid place-items-center px-6" style={{ background: "#FDFBF7" }}>
      <div className="text-center max-w-md fade-up" data-testid="payment-cancel-page">
        <Heart size={22} className="text-[#8C9A86] mx-auto mb-6" fill="#8C9A86" />
        <div className="w-16 h-16 rounded-full bg-stone-100 text-stone-400 grid place-items-center mx-auto mb-6">
          <XCircle size={30} />
        </div>
        <h1 className="font-serif text-3xl tracking-tight">Payment cancelled</h1>
        <p className="text-stone-500 mt-3">No charge was made. Your event details are still saved. You can try again whenever you're ready.</p>
        <button onClick={() => navigate("/setup")} data-testid="cancel-back-btn"
          className="mt-6 rounded-full bg-[#2C2A28] text-white px-6 py-3 text-sm hover:bg-[#8C9A86] transition-colors">
          Back to setup
        </button>
      </div>
    </div>
  );
}
